module.exports = __webpack_public_path__ + "static/preview-faro-800-20eb7a7aefeb04a42273a8e8d16e975b.jpg";